import * as HttpService from './http.service';
import * as URL from './url.service';

export const getWorkspaceHistory = (cursor = null) => HttpService.getWithAuth(URL.WORKSPACE_HISTORY(cursor));
export const createWorkspaceHistoryTile = (payload) => HttpService.postWithAuth(URL.WORKSPACE_EXECUTE(), payload);
export const getWorkspaceFavourites = () => HttpService.getWithAuth(URL.WORKSPACE_FAVOURITES());
export const toggleWorkspaceFavourite = (payload) => HttpService.postWithAuth(URL.TOGGLE_WORKSPACE_FAVOURITE(), payload);
